// extracted by mini-css-extract-plugin
export var brand = "_bf-9";
export var compact = "_bf-6";
export var extraSmall = "_bf-7";
export var icon = "_bf-0";
export var large = "_bf-4";
export var light = "_bf-1";
export var medium = "_bf-5";
export var outline = "_bf-b";
export var primaryDark = "_bf-a";
export var primaryLight = "_bf-8";
export var primaryModern = "_bf-c";
export var success = "_bf-2";
export var successSolid = "_bf-3";